import React, { useEffect, useState } from 'react';
import { Modal, Switch, Checkbox, Divider, Space, Typography } from 'antd';
import { GraphNetworkSimulatorBridge } from '../Device/Bridge';

const networkOptions = [
  '计算机',
  '交换机',
  '无线路由器',
  'DHCP服务器',
  '移动终端',
  '无线接入点',
  '调制解调器',
  '路由器',
  '防火墙',
];

const iotOptions = [
  '智能音箱',
  '智能门铃',
  '智能门锁',
  '智能灯泡',
  '投影机',
  '空调',
  '投影幕布',
];

export default function DeviceUIConfigModal(props) {
  const { visible, uiConfig, onClose, onSave } = props;
  const [config, setConfig] = useState(GraphNetworkSimulatorBridge.getDefaultUIConfig());
  const { Text } = Typography;

  useEffect(() => {
    if (uiConfig) {
      setConfig({
        ...GraphNetworkSimulatorBridge.getDefaultUIConfig(),
        ...uiConfig,
      });
    }
  }, [uiConfig]);

  const updateConfig = (next) => {
    setConfig((prev) => ({
      ...prev,
      ...next,
    }));
  };

  const handleOk = () => {
    if (onSave) {
      onSave(config);
    }
  };

  return (
    <Modal
      visible={visible}
      title="界面配置"
      onCancel={onClose}
      onOk={handleOk}
      okText="保存"
      cancelText="取消"
      destroyOnClose
      width={720}
    >
      <Divider style={{ margin: '12px 0' }}>
        <Space align="center">
          <Text strong>网络</Text>
          <Switch
            size="small"
            checked={config.networkTabEnabled}
            onChange={(checked) => updateConfig({ networkTabEnabled: checked })}
          />
        </Space>
      </Divider>
      {config.networkTabEnabled ? (
        <Checkbox.Group
          style={{ width: '100%' }}
          options={networkOptions}
          value={config.networkDevices}
          onChange={(list) => updateConfig({ networkDevices: list })}
        />
      ) : null}

      <Divider style={{ margin: '16px 0' }}>
        <Space align="center">
          <Text strong>物联网</Text>
          <Switch
            size="small"
            checked={config.iotTabEnabled}
            onChange={(checked) => updateConfig({ iotTabEnabled: checked })}
          />
        </Space>
      </Divider>
      {config.iotTabEnabled ? (
        <Checkbox.Group
          style={{ width: '100%' }}
          options={iotOptions}
          value={config.iotDevices}
          onChange={(list) => updateConfig({ iotDevices: list })}
        />
      ) : null}
    </Modal>
  );
}
